import { PlansList } from "../Model/paymentObjects";

export const PLANS = "PLANS";

const initialState = new PlansList([]);

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case PLANS:
            return action.payload;
        default:
            return state;
    }
}

const storeName = "plans";

const storeMapping = {[storeName]: reducer};

export const plansSelector = (state) => state[storeName];

export default storeMapping;
